import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "HeaderChunksAndFooterLazy" */ './YodaTooltip'),
    { fallback: null }
);
